import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';

import { APP_CONFIG, APP_DI_CONFIG } from './app.config';
import { MetadataService } from './shared/services/metadata.service';
import { MetadataLayerService } from './shared/services/metadata.layers.service';
import { HttpWrapper } from './http/HttpWrapper';
import { AwgSharedServiceService } from './shared/services/awg-shared-service.service';
import { IntegrationService } from './shared/services/integration.service';
import { MapAbstractService } from './shared/services/map/map-abstract.service';
import { MapService } from './shared/services/map/map.service';
import { LoggerService } from './log/logger.service';
import { ConsoleLoggerService } from './log/console-logger.service';
import { TokenService } from './shared/services/token.service';
import { AuthInterceptor } from './shared/interceptor/authinterceptor.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RicercaService } from './shared/services/ricerca.service';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './shared/services/auth.service';
import { OAuthModule } from 'angular-oauth2-oidc';
import { LoaderService } from './shared/loader/loader.service';
import { LoaderInterceptorService } from './shared/loader/loader-interceptors.service';
import { LoaderModule } from './shared/loader/loader.component';
import { PanelEvent } from './shared/PanelEvent';
import { MaterialModule } from './shared/modules/material-modules';

import localeIt from '@angular/common/locales/it';
import { MenuComponent } from './layout/dossier/menu/menu.component';
import { SelezionecuaaComponent } from './layout/dossier/selezionecuaa/selezionecuaa.component';
import { LayoutService } from './shared/services/layout.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from './layout/components/footer/footer.component';
import { TopbarComponent } from './layout/components/topbar/topbar.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ToastrMessagesService } from './shared/services/toastr-messages.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { UsersService } from './shared/services';

// AoT requires an exported function for factories
export const createTranslateLoader = (http: HttpClient) => {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};

@NgModule({
    imports: [
        ToastModule,
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        NgxSliderModule,
        MaterialModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule,
        OAuthModule.forRoot(),
        LoaderModule,
        FormsModule,
        ReactiveFormsModule,
        ToastModule,
        ToastrModule.forRoot()  
    ],
    declarations: [AppComponent, MenuComponent, SelezionecuaaComponent, FooterComponent, TopbarComponent],
    providers: [
        UsersService,
        MessageService,
        AuthGuard,
        { provide: LOCALE_ID, useValue: 'it' },
        { provide: APP_CONFIG, useValue: APP_DI_CONFIG },
        MetadataService,
        MetadataLayerService,
        TokenService,
        HttpWrapper,
        AwgSharedServiceService,
        IntegrationService,
        RicercaService,
        AuthService,
        LayoutService,
        NgxChartsModule,
        { provide: MapAbstractService, useClass: MapService },
        { provide: LoggerService, useClass: ConsoleLoggerService },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            // interceptor to show loading spinner
            // tenere LoaderInterceptor come ultimo degli HTTP_INTERCEPTORS in lista
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptorService,
            multi: true,
        },
        CookieService,
        LoaderService,
        PanelEvent,
        ToastrMessagesService, 
        ToastrService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor() {
        registerLocaleData(localeIt, 'it');
    }
}
